/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_7_PInputs */

const en_terms_7_p = /** @type {(inputs: Terms_7_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The service is provided as is. We aim for high availability but do not guarantee it. To the extent permitted by law, our total liability for any claim is limited to the amount you paid us in the 3 months before the claim, and we are not liable for indirect or consequential loss.`)
};

const id_terms_7_p = /** @type {(inputs: Terms_7_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layanan disediakan sebagaimana adanya. Kami mengupayakan ketersediaan tinggi tetapi tidak menjaminnya. Sejauh diizinkan hukum, total tanggung jawab kami atas klaim apa pun dibatasi sebesar jumlah yang kamu bayarkan dalam 3 bulan sebelum klaim, dan kami tidak bertanggung jawab atas kerugian tidak langsung.`)
};

/**
* | output |
* | --- |
* | "The service is provided as is. We aim for high availability but do not guarantee it. To the extent permitted by law, our total liability for any claim is lim..." |
*
* @param {Terms_7_PInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const terms_7_p = /** @type {((inputs?: Terms_7_PInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_7_PInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_terms_7_p(inputs)
	return en_terms_7_p(inputs)
});